import { http } from '@/core/api/';

const messageBaseURL = 'api/message';

export default {
  fetchApplication() {
    return http.get(`${messageBaseURL}/applications`);
  },
  fetchLocation() {
    return http.get(`api/code/getcodebytype?type=MessageLocation`);
  },
  fetchRol() {
    return http.get(`${messageBaseURL}/roles`);
  },
  fetchResult(filter) {
    return http.get(`${messageBaseURL}/search`, {
      params: filter,
    });
  },
  fetchMessageById(id) {
    return http.get(`${messageBaseURL}/${id}`);
  },
  deleteMessage(id) {
    return http.delete(`${messageBaseURL}/delete/${id}`);
  },
  updateMessage(data) {
    return http.put(`${messageBaseURL}/edit`, data, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  },
  saveMessage(data) {
    return http.post(`${messageBaseURL}/save`, data, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  },
};
